/**
 * Единый источник имён array-полей фильтра декора (для `useCatalogFilters`).
 *
 * Держим в отдельном не-компонентном модуле, чтобы экран фильтр+список
 * (`DecorsCatalog`, /decors/:kind/catalog) не дрейфовал при добавлении 4-го поля
 * (B-021 multi-type). Не в `DecorFilterChips.tsx` — react-refresh не любит
 * value-export рядом с компонентом.
 */
export const DECOR_FILTER_FIELDS = ['subcategories', 'brands', 'types'] as const;
